const UAParser = require("ua-parser-js");
const userAgentParser = new UAParser();

export const device = {
  async getId() {
    return "";
  },

  async getModel() {
    return "web";
  },

  async getModelCode() {
    return "";
  },

  async getRealModel() {
    return "";
  },

  async getPlatform() {
    return "web";
  },

  async getServerVersion() {
    return "";
  },

  async getYear() {
    return "";
  },

  async supports4K() {
    return false;
  },

  async getFirmwareVersion() {
    return false;
  },

  getManufacturer() {
    return "";
  },

  getType() {
    /**
     * From getDevice() method docs on https://github.com/faisalman/ua-parser-js, possible 'device.type' are:
     * console, mobile, tablet, smarttv, wearable, embedded
     */
    return userAgentParser.getDevice().type;
  },

  getOperatingSystem() {
    /**
     * From getOS() method docs on https://github.com/faisalman/ua-parser-js, possible 'os.name' are:
     * AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, CentOS, Chromium OS, Contiki,
     * Fedora, Firefox OS, FreeBSD, Debian, DragonFly, Fuchsia, Gentoo, GNU, Haiku, Hurd, iOS,
     * Joli, Linpus, Linux, Mac OS, Mageia, Mandriva, MeeGo, Minix, Mint, Morph OS, NetBSD,
     * Nintendo, OpenBSD, OpenVMS, OS/2, Palm, PC-BSD, PCLinuxOS, Plan9, Playstation, QNX, RedHat,
     * RIM Tablet OS, RISC OS, Sailfish, Series40, Slackware, Solaris, SUSE, Symbian, Tizen,
     * Ubuntu, Unix, VectorLinux, WebOS, Windows [Phone / Mobile], Zenwalk...
     */
    return userAgentParser.getOS().name;
  }
};
